(function() {
  'use strict';

  // Initialize helper
  function initHelper() {
    setupRebuyAPI();
    monitorRebuyActivity();
  }

  function setupRebuyAPI() {
    // Wait for Rebuy to be available
    function waitForRebuy() {
      if (typeof window.Rebuy !== 'undefined') {
        enhanceRebuyAPI();
      } else {
        setTimeout(waitForRebuy, 100);
      }
    }
    
    waitForRebuy();
  }

  function enhanceRebuyAPI() {
    // Override Rebuy's cart methods if available
    if (window.Rebuy && window.Rebuy.Cart) {
      const originalAddItem = window.Rebuy.Cart.addItem;
      
      if (originalAddItem) {
        window.Rebuy.Cart.addItem = function(...args) {
          // Call original method
          const result = originalAddItem.apply(this, args);
          
          // Trigger our custom event
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('rebuy:item.added', {
              detail: { args: args, timestamp: Date.now() }
            }));
          }, 50);
          
          return result;
        };
      }

      // Override other Rebuy methods
      const originalUpdateCart = window.Rebuy.Cart.update;
      if (originalUpdateCart) {
        window.Rebuy.Cart.update = function(...args) {
          const result = originalUpdateCart.apply(this, args);
          
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('rebuy:cart.updated', {
              detail: { args: args, timestamp: Date.now() }
            }));
          }, 50);
          
          return result;
        };
      }
    }
  }



  function monitorRebuyActivity() {
    // Monitor for Rebuy widget additions
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches && 
              node.matches('[data-rebuy-id], [class*="rebuy"], .rebuy-widget')) {
            
            enhanceWidget(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Enhance existing widgets
    document.querySelectorAll('[data-rebuy-id], [class*="rebuy"], .rebuy-widget')
      .forEach(enhanceWidget);
  }

  function enhanceWidget(widget) {
    if (widget.dataset.helperEnhanced) return;

    // Add event listeners for functionality
    widget.addEventListener('click', (event) => {
      const target = event.target;

      // Check for add to cart buttons
      if (target.matches('button, .button, [role="button"], a')) {
        const text = target.textContent.toLowerCase();
        const isCartButton = text.includes('add') || text.includes('cart') || text.includes('buy');
        
        if (isCartButton) {
          // Dispatch custom event for our main integration
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('rebuy:button.clicked', {
              detail: { 
                button: target, 
                widget: widget,
                text: text,
                timestamp: Date.now() 
              }
            }));
          }, 10);
        }
      }
    }, true);

    // Monitor form submissions within widgets
    const forms = widget.querySelectorAll('form');
    forms.forEach(form => {
      form.addEventListener('submit', (event) => {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('rebuy:form.submitted', {
            detail: { 
              form: form,
              widget: widget,
              timestamp: Date.now() 
            }
          }));
        }, 10);
      });
    });

    widget.dataset.helperEnhanced = 'true';
  }

  // Enhanced cart monitoring
  function createCartMonitor() {
    let lastKnownCart = null;

    function checkCart() {
      fetch(`${window.routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          if (lastKnownCart && cart.item_count > lastKnownCart.item_count) {
            // Find new items
            const newItems = cart.items.filter(item => 
              !lastKnownCart.items.some(oldItem => oldItem.key === item.key)
            );

            if (newItems.length > 0) {
              window.dispatchEvent(new CustomEvent('rebuy:cart.helper.updated', {
                detail: { 
                  newItems: newItems,
                  cart: cart,
                  previousCart: lastKnownCart,
                  timestamp: Date.now()
                }
              }));
            }
          }
          
          lastKnownCart = cart;
        })
        .catch(error => {
          // Silent error handling
        });
    }

    // Check cart every 1 second
    setInterval(checkCart, 1000);
    
    // Initial check
    checkCart();
  }

  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHelper);
  } else {
    setTimeout(initHelper, 50);
  }

  // Start cart monitoring
  setTimeout(createCartMonitor, 100);



})();